import postshopLocatorReducer, {PostshopLocatorState} from "./reducers/postshop-locator/postshopLocatorReducer";

export {
  postshopLocatorReducer,
  PostshopLocatorState,
}

export {paths} from "../routes/routes";


// WEBPACK FOOTER //
// ./src/redux/external.ts